import { Flow_0_0_2 } from '@flexus/core';

export const BUI_11: Flow_0_0_2 = {
	id: '11',
	name: 'work_complete_private_job',
	itemType: 'flow',
	header: {
		title: '',
		controls: () => () => []
	},
	footer: {
		type: 'node_nav'
	},
	instructions: {
		editRoles: {
			0: 'Placeholder'
		},
		viewRoles: {
			0: 'Placeholder'
		}
	},
	startNode: '',
	nodes: {}
};
